<template>
  <el-dialog
    :title="isUpdate ? '更新分销商品完成' : (totalNum > 1 ? '批量加分销商品完成' : '加分销商品完成')"
    :visible.sync="dialogVisible"
    width="470px"
    >
    <div style="text-align: justify;padding-top: 20px;">
        商品总数：{{ totalNum }}款，成功{{ successNum }}款，
        <span v-if="partSuccessNum">部分成功{{ partSuccessNum }}款</span>
        <span v-else>失败{{ failureNum }}款</span>
        <br>
        <br>
        <br>
        <template v-if="failureNum || partSuccessNum">
            失败原因：<span class="text-orange">{{ errorMsg }}</span>
        </template>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleJump">查看日志</el-button>
    </span>
</el-dialog>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
export default {
  data() {
    return {
      dialogVisible: false,
      error: {},
      isUpdate: false
    }
  },
  computed: {
    ...mapGetters(['routerPrefix']),
    totalNum() {
        return this.error.totalNum || 0
    },
    successNum() {
        return this.error.successNum || 0
    },
    failureNum() {
        return this.error.failureNum || 0
    },
    partSuccessNum() {
        return this.error.partSuccessNum || 0
    },
    errorMsg() {
        return this.error.errorMsg || '无错误信息'
    },
  },
  methods: {
    ...mapMutations(['setActiveName']),
    method_open(error = {}, isUpdate = false) {
      this.dialogVisible = true;
      this.error = error;
      this.isUpdate = isUpdate;
    },
     // 跳到商品日志中商品新增tab页
    handleJump() {
      this.setActiveName('newProductLog');
       this.dialogVisible = false;
      this.$router.push({name: `${this.routerPrefix}prod_log`});
    }
  }

}
</script>

<style lang="scss" scoped>

</style>
